<script lang="ts">
import { defineComponent, PropType } from "vue"
import { AlarmNotificationState } from "@/types/alarm-notification"

const states: AlarmNotificationState[] = ["DEFAULT", "INCLUDE", "EXCLUDE"]

export default defineComponent({
    name: "AlarmNotificationToggle",
    props: {
        value: {
            type: String as PropType<AlarmNotificationState>,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return { states }
    },
})
</script>

<template>
    <div class="btn-group flex-shrink-0" :class="{ 'd-flex': block }" role="group">
        <button
            v-for="state in states"
            :key="state"
            type="button"
            class="btn btn-sm"
            :class="[value === state ? 'btn-primary' : 'btn-secondary', { 'w-100': block }]"
            :aria-pressed="value === state"
            :disabled="disabled"
            @click="value !== state && $emit('input', state)"
        >
            {{ $t(`alarm_notifications.state.${state.toLowerCase()}`) }}
        </button>
    </div>
</template>
